__turbopack_context__.v({
  "col": "StoryBlock-module__c8IByW__col",
  "figure": "StoryBlock-module__c8IByW__figure",
  "grid1Col": "StoryBlock-module__c8IByW__grid1Col",
  "grid2Col": "StoryBlock-module__c8IByW__grid2Col",
  "paragraph": "StoryBlock-module__c8IByW__paragraph",
  "storyBlock": "StoryBlock-module__c8IByW__storyBlock",
  "subtitle": "StoryBlock-module__c8IByW__subtitle",
  "title": "StoryBlock-module__c8IByW__title",
});
